<template>
  <div class="container-fluid">
    <b-row>
      <b-col>
        <div style="display: flex; flex-wrap: wrap;">
          <span v-for="(state, index) in current_states" :key="state.id">
            <slot class="mt-4" :name="state.trigger__value.code"></slot>
            <trigger-button
              class="mr-2 mb-2"
              :trigger="state.trigger__value"
              :item="item"
              :instance-id="workflowInstance.id"
              @success="reload"
              :do-save="doSave"
              :disabled="isDisabled(state)"
            >
            </trigger-button>
          </span>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import _ from "lodash";
import TriggerButton from "./TriggerButton.vue";

export default {
  name: "TriggerButtons",
  components: {
    TriggerButton,
  },
  props: {
    workflowInstance: { type: Object, default: () => {} },
    currentUser: { type: Object, default: () => {} },
    item: { type: Object, default: () => {} },

    doSave: { type: Function, default: null },

    disabledButtons: { type: Object, default: () => {} },
  },
  methods: {
    ...mapMutations(["showMessage"]),

    showMessageError(message) {
      this.showMessage({
        message: message,
        type: "danger",
        show: true,
      });
    },
    reload(data) {
      this.$emit("success");
    },

    isDisabled(state) {
      if (state && state.trigger__value) {
        var trigger_code = state.trigger__value.code;
        if (trigger_code in this.disabledButtons) {
          return this.disabledButtons[trigger_code];
        }
      }

      return false;
    },
  },
  computed: {
    current_states() {
      const user_groups_map = this.user_groups_map;

      if (!this.workflowInstance.states) {
        return [];
      }

      return _.filter(this.workflowInstance.states, function (s) {
        // Is the trigger a "button" that is Active?
        var allow = s.is_current && s.trigger__value.type === 1;

        if (allow) {
          //Does the trigger have any of the Groups the currentUser is in?

          var group_match = false;

          _.forEach(s.trigger__value.group_ids, function (group_id) {
            if (user_groups_map[group_id]) {
              // Yes we are in the same groups
              group_match = true;
            }
          });

          if (!group_match) {
            allow = false;
          }
        }

        return allow;
      });
    },
    user_groups_map() {
      if (this.currentUser) {
        return _.keyBy(this.currentUser.groups, "id");
      } else {
        return {};
      }
    },
  },
};
</script>

<style scoped>
.marginb-50 {
  margin-bottom: 50px;
}
</style>
